<!-- textarea输入框 -->
<template>
  <div class="form_textarea_wrap text_a_left bd_c_f margin_b_10">
    <div
      class="form_item_name"
      :class="option.isRequire ? 'form_item_isNeed' : ''"
      v-if="layout === 'vertical'"
    >
      {{ option.label }}
    </div>
    <div
      v-if="option.hasDescription && layout === 'vertical'"
      class="form_item_desc"
    >
      {{ option.description }}
    </div>
    <van-divider v-if="layout === 'vertical'" />
    <!-- <van-cell-group> -->
    <van-field
      :label="layout === 'horizontal' ? option.label : null "
      :class="layout === 'horizontal' ? (option.isRequire ? 'form_item_horizontal_isNeed form_label_vertical_center' : 'form_label_vertical_center') : '' "
      type="textarea"
      v-model="option.value"
      :name="option.name"
      :error="error"
      :error-message="errorMessage"
      :placeholder="option.placeholder"
      :rules="[
        {
          validator: asyncValidator,
          message:$t('form.validator.require')
        }
      ]"
    />
    <!-- </van-cell-group> -->
  </div>
</template>

<script>
export default {
  name: 'FormTextarea',
  props: {
    option: {
      type: Object,
      default: () => ({})
    },
    layout: {
      type: String,
      default: "horizontal" // horizontal 水平 vertical 垂直
    }
  },
  data() {
    return {
      error: false,
      errorMessage: ''
    }
  },

  components: {},

  methods: {
    //格式校验方法
    asyncValidator(value) {
      return new Promise(resolve => {
        if (value.length > 0) {
          resolve(this.SetCheckSuccMsg())
        } else {
          if (this.option.isRequire) {
            resolve(this.SetCheckErrorMsg(this.$t('form.validator.require')))
          } else {
            resolve(this.SetCheckSuccMsg())
          }
        }
      })
    },
    // 设置校验不通过提示内容
    SetCheckErrorMsg(msg) {
      this.error = true
      this.errorMessage = msg
      return false
    },
    // 设置校验通过提示内容
    SetCheckSuccMsg() {
      this.error = false
      this.errorMessage = ''
      return true
    }
  },

  mounted() { }
}
</script>
<style lang="less" scoped></style>
